function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef } from 'react';

var ComponentList = function ComponentList(_ref) {
  var Component = _ref.Component,
      componentPropsList = _ref.componentPropsList;
  var isBrowser = typeof window !== 'undefined';
  var pageYOffset = isBrowser ? window.pageYOffset : undefined; // Keep scroll position when the list of items changes

  var prevComponentPropsList = useRef(componentPropsList);
  useEffect(function () {
    if (isBrowser && pageYOffset !== undefined && prevComponentPropsList.current !== componentPropsList) {
      prevComponentPropsList.current = componentPropsList;
      window.scrollTo({
        top: pageYOffset
      });
    }
  }, // This effect should trigger only on componentPropsList change (not on pageYOffset change)
  [isBrowser, componentPropsList] // eslint-disable-line react-hooks/exhaustive-deps
  );
  return /*#__PURE__*/React.createElement(React.Fragment, null, componentPropsList.map(function (componentProps) {
    return /*#__PURE__*/React.createElement(Component, _extends({}, componentProps, {
      key: componentProps.id
    }));
  }));
};

export default ComponentList;